import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SecureImage from './SecureImage';

const ImageZoomDialog = ({ open, imageUrl, onClose }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            PaperProps={{
                sx: {
                    bgcolor: 'transparent',
                    boxShadow: 'none',
                    overflow: 'visible',
                    maxWidth: 'fit-content',
                }
            }}
        >
            <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <SecureImage
                    url={imageUrl}
                    alt="Zoomed"
                    sx={{
                        maxWidth: '95vw',
                        maxHeight: '95vh',
                        objectFit: 'contain',
                        bgcolor: 'background.paper',
                        borderRadius: 1,
                        boxShadow: 24
                    }}
                />
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        top: -20,
                        right: -20,
                        bgcolor: 'white',
                        color: 'action.active',
                        boxShadow: 2,
                        '&:hover': {
                            bgcolor: 'grey.100',
                        },
                        zIndex: 1
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
        </Dialog>
    );
};

export default ImageZoomDialog;
